import { Clock, Phone } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import WhatsAppIcon from "./WhatsAppIcon";
import Reveal from "./Reveal";
import { LAWYERS, LEGAL_SERVICES, OFFICE } from "../../data/content";

const DespachoSection = () => {
  return (
    <section id="despacho" className="section-despacho" data-testid="despacho-section">
      <div className="rr-container">
        <div className="despacho-head">
          <div className="logo-badge">
            <img src="/assets/logo-despacho.jpg" alt="Despacho Jurídico Rendón Ramos" />
          </div>
          <div>
            <span className="section-eyebrow">Despacho Jurídico Rendón Ramos</span>
            <h2 className="section-title font-display" style={{ color: "#ffffff" }}>
              Nuestros abogados
            </h2>
            <p className="section-desc">
              Un equipo con posgrados y experiencia comprobada, comprometido con la defensa de sus
              derechos. Escríbanos directamente por WhatsApp.
            </p>
          </div>
        </div>

        <div className="lawyer-grid">
          {LAWYERS.map((lawyer, idx) => (
            <Reveal key={lawyer.id} delay={idx * 0.12} className="lawyer-card" data-testid={`lawyer-card-${lawyer.id}`}>
              <div className="lawyer-photo">
                <img src={lawyer.photo} alt={lawyer.name} loading="lazy" data-testid={`lawyer-photo-${lawyer.id}`} />
              </div>
              <h3 className="lawyer-name font-display">{lawyer.name}</h3>
              <div className="lawyer-creds">
                {lawyer.credentials.map((c) => (
                  <span key={c} className="cred-chip">
                    {c}
                  </span>
                ))}
              </div>
              <div className="lawyer-phone" data-testid={`lawyer-phone-${lawyer.id}`}>
                {lawyer.phoneDisplay}
              </div>
              <a
                href={lawyer.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp"
                data-testid={`whatsapp-btn-${lawyer.id}`}
              >
                <WhatsAppIcon size={18} /> WhatsApp
              </a>
            </Reveal>
          ))}
        </div>

        <div className="hours-banner" data-testid="hours-banner">
          <Clock size={19} style={{ color: "var(--rr-gold-light)" }} />
          Horario de atención: {OFFICE.hours}
        </div>

        <div className="services-wrap">
          <h3 className="services-title font-display" data-testid="services-title">
            ⚖️ Servicios Jurídicos
          </h3>
          <p className="services-sub">
            Despliegue cada materia para conocer todos los servicios que ofrecemos.
          </p>
          <Accordion type="multiple" defaultValue={["civil"]} data-testid="services-accordion">
            {LEGAL_SERVICES.map((cat) => (
              <AccordionItem key={cat.id} value={cat.id} className="service-acc-item">
                <AccordionTrigger className="service-acc-trigger" data-testid={`service-cat-${cat.id}`}>
                  <span>
                    {cat.icon}&nbsp;&nbsp;{cat.title}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="service-acc-content">
                  {cat.items ? (
                    <ul className="service-list">
                      {cat.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    cat.groups.map((group) => (
                      <div key={group.title}>
                        <div className="service-subgroup-title">{group.title}</div>
                        <ul className="service-list">
                          {group.items.map((item) => (
                            <li key={item}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    ))
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="office-cta" data-testid="office-cta">
          <h4 className="font-display">¿Necesita asesoría? Llámenos a oficina</h4>
          <p>Con gusto le atendemos de lunes a sábado, de 8:00 am a 4:00 pm.</p>
          <a href={OFFICE.phoneTel} className="btn office-phone-btn" data-testid="office-call-btn">
            <Phone size={20} /> {OFFICE.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
};

export default DespachoSection;
